// USER SUBSCRIPTION CLOSE REQUEST ****************************************************************************
// pathname: /v2/publication/activation-services/{jobSlug}
// ************************************************************************************************
import { ApiUserSubscriptionCloseRequest, useSwrApi } from 'src/hooks/useSwrApi';

/**
 * @description SWR: post a close request for user subscription
 * @param locale
 * @param postData
 * @param fetchCondition
 * @param successCallback
 * @example
 * const [postingData, setPostingData] = useState({});
 * const { data: activationServices } = useSwrCloseRequest('ro', postingData, (step === 3));
 */
export const useSwrCloseRequest = (locale: string, postData: object, fetchCondition?: boolean, successCallback?: () => void) => {
  const {
    data, error, mutate, isValidating, isLoading,
  } = useSwrApi<ApiUserSubscriptionCloseRequest>({
    url: '/v1/user-subscription/close-request',
    locale,
    shouldFetch: fetchCondition,
    fetcherConfig: {
      method: 'PUT',
      payload: postData,
      stringifyPayload: true,
    },
    apiOptions: {
      onSuccess: () => {
        if (successCallback) successCallback();
      },
    },
    toastsOptions: {
      showSuccessToast: true,
      showErrorToast: true,
    },
  });

  // return data
  return {
    data,
    error,
    mutate,
    isValidating,
    isLoading,
  };
};
